import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// ScrollToTop — react-router återställer INTE scroll-position vid route-byte
// per default. Den här komponenten lyssnar på pathname-ändringar och
// scrollar till toppen på varje navigation.
//
// Placeras inuti <BrowserRouter> men utanför <Routes>. Påverkar bara
// route-navigations — användaren kan fortfarande scrolla normalt inom
// en sida utan att triggas.
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Använd 'instant' istället för 'smooth' så användaren inte ser
    // den gamla sidans innehåll susa förbi när de byter sida.
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
  }, [pathname]);

  return null;
}
